module.exports = __webpack_public_path__ + "img/market-activity-07.08ee5278.jpg";